import type { DetailedKiosk, StoredKiosk } from 'modules/kiosks/types';

/**
 * Narrows a stored kiosk to the `details` projection. The entity adapter merges projections by
 * id, so a kiosk that was only ever seen through `page` carries neither `config` nor the medias.
 * @param kiosk the kiosk as the store holds it
 */
export const isDetailedKiosk = (kiosk: StoredKiosk): kiosk is DetailedKiosk => 'config' in kiosk;
